<template>
  <InvioPDC />
</template>

<script>
import InvioPDC from '../components/pratiche/invio-pdc/InvioPDC.vue'

export default {
  components: {
    InvioPDC
  },
  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  }
}
</script>
  